import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Busqueda from './components/Busqueda';

const Busqueda_llave_nombre = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
      </Col>
    </Row>
    <Row>
      <Busqueda />
    </Row>
  </Container>
);

export default Busqueda_llave_nombre;
